import { render } from "./NumberGenerator.vue?vue&type=template&id=5f1c2b24&scoped=true"
import script from "./NumberGenerator.vue?vue&type=script&lang=js"
export * from "./NumberGenerator.vue?vue&type=script&lang=js"

import "./NumberGenerator.vue?vue&type=style&index=0&id=5f1c2b24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1c2b24"]])

export default __exports__